app.controller('BrowseJourneySolutionController', ['$rootScope', '$scope', '$state', '$window', function ($rootScope, $scope, $state, $window) {

    const siteHelper = $rootScope.site_helper;

    const navigationIDs = $scope.navigation_ids;
    const solutionID = navigationIDs.solution_id;
    const categoryID = "solution_" + solutionID;
    let categoryCache = null;
    $scope.category_cart_id = "";

    const journeyNavigationModel = new $rootScope.navigation_manager.NavigationModel();

    let haveAnyProducts = false;

    let currentSolutionProducts = {};
    $scope.complete_only_cart = [];
    $scope.non_complete_cart = [];
    $scope.unrelated_cart = [];

    $scope.step_choice_list = [];
    let haveCompleteInput = false;

    let inputStepChoice = null;

    let navigationStepID = null;
    let showInput = false;
    let navigationInputComplete = false;

    let firstProductStepID = null;


    let lastSelectTime = 0;
    const minSelectElapsedTime = 150;

    let validatePagePositionCalled = false;

    $scope.intro_video_link = null;
    $scope.solution_option_terms = [];
    $scope.can_change_cabinet_options = false;
    $scope.have_solution_order_data = $rootScope.model.order.is_order_initialized;

    $scope.do_fix_height = !$rootScope.site_helper.isTouchDevice();
    $scope.minimum_journey_view_height = 0;


    const StepChoice = function (id) {
        this.id = id;
        this.step_number = 0;
        this.name = "";
        this.component_choice = null;
        this.disabled = false;
        this.has_progress = false;
        this.completed = false;
        this.description = "";
        this.step_values = [];
        this.status = "";
    }

    const SolutionOptionTerm = function (optionID, optionTermModel) {
        this.option_id = optionID;
        this.option_term_model = optionTermModel;
        this.defaultOptionTermID = "";
        this.currentOptionTermID = "";
    }

    function populateSolution() {

        requireCategoryCache();
        determineOptionChoices();
        checkForDataAPI();
        updateSolution();

        if (validateCurrentStep()) {
            $scope.validatePagePosition();
        }
    }

    function updateSolution() {
        populateJourneyNavigationModel();
        populateSteps()
        determineCurrentSolutionProducts();
        updateStepChoices();
        determineNavigationValues();
    }

    $scope.overrideCacheInputChoiceIDs = function (withIDs) {
        requireCategoryCache();
        const cachedChoiceIDs = categoryCache.input_choice_ids;

        for (let navigationPointer in cachedChoiceIDs) {
            delete cachedChoiceIDs[navigationPointer];
        }
        for (let navigationPointer in withIDs) {
            cachedChoiceIDs[navigationPointer] = withIDs[navigationPointer];
        }
        $rootScope.service.cache_browse.saveCategoryCache(categoryID);
    }

    function populateJourneyNavigationModel() {
        const navigationStateList = $rootScope.navigation_model.state_list;

        const routePath = [];
        const defaultChoiceIDs = {
            site_range: ["valore"]
        }

        haveCompleteInput = true;
        let cachedChoiceIDs = categoryCache.input_choice_ids;
        const remainingCachedChoiceIDs = {}

        function populateFromModel(model) {
            if (!model.choice_order.length) {
                return;
            }
            let choiceID = null;
            if (haveCompleteInput) {
                const navigationPointer = model.navigation_pointer;
                const cachedChoiceID = cachedChoiceIDs[navigationPointer];
                //cachedChoiceID = null;
                if (cachedChoiceID && model.choice_order.includes(cachedChoiceID)) {
                    choiceID = cachedChoiceID;
                    remainingCachedChoiceIDs[navigationPointer] = choiceID;
                } else {
                    haveCompleteInput = false;
                }
            }
            if (!choiceID) {
                const fromDefaultChoiceIDs = defaultChoiceIDs[model.id];
                if (fromDefaultChoiceIDs) {
                    for (let j = 0; j < fromDefaultChoiceIDs.length; j++) {
                        const checkChoiceID = fromDefaultChoiceIDs[j];
                        if (model.choice_order.includes(checkChoiceID)) {
                            choiceID = checkChoiceID;
                            break;
                        }
                    }
                }
            }
            if (!choiceID) {
                if (model.default_choice_id) {
                    choiceID = model.default_choice_id;
                } else {
                    choiceID = model.choice_order[0];
                }
            }
            routePath.push(choiceID);
            $rootScope.navigation_manager.populateNavigationModel(journeyNavigationModel, routePath);
            const indexState = journeyNavigationModel.state_list[journeyNavigationModel.state_list.length - 1];
            if (indexState.model_id === "component" || indexState.choice_id || model.id === "component") {
                return;
            }
            populateFromModel(indexState.model);
        }

        let solutionFound = false;

        for (let i = 0; i < navigationStateList.length; i++) {
            const navigationIndexState = navigationStateList[i];
            if (navigationIndexState.model_id === "component") {
                $rootScope.navigation_manager.populateNavigationModel(journeyNavigationModel, routePath);
                haveCompleteInput = true;
                break;
            }

            if (!navigationIndexState.choice_id) {
                populateFromModel(navigationIndexState.model);
                break;
            }

            routePath.push(navigationIndexState.choice_id);

            if (!solutionFound) {
                if (navigationIndexState.state_ids.solution_id) {
                    solutionFound = true;
                }
            } else {
                const navigationPointer = navigationIndexState.navigation_pointer;
                remainingCachedChoiceIDs[navigationPointer] = navigationIndexState.choice_id;
            }
        }

        let cacheWasReplaced = false;
        let cacheDidChange = false;
        for (let key in cachedChoiceIDs) {
            if (remainingCachedChoiceIDs[key] !== cachedChoiceIDs[key]) {
                cacheWasReplaced = true;
                cacheDidChange = true;
                break;
            }
        }
        if (cacheWasReplaced) {
            cachedChoiceIDs = remainingCachedChoiceIDs;
            resetProducts();
        } else {
            for (let key in remainingCachedChoiceIDs) {
                if (cachedChoiceIDs[key] !== remainingCachedChoiceIDs[key]) {
                    cacheDidChange = true;
                }
            }
        }
        if (cacheDidChange) {
            categoryCache.input_choice_ids = remainingCachedChoiceIDs;
            $rootScope.service.cache_browse.saveCategoryCache(categoryID);
        }
    }

    function determineCurrentSolutionProducts() {

        let orderLines = $rootScope.model.order.current_order ? $rootScope.model.order.current_order.lines : null;

        orderLines = orderLines ? orderLines : [];

        haveAnyProducts = false;
        currentSolutionProducts = {};

        $scope.complete_only_cart.length = 0;
        $scope.non_complete_cart.length = 0;
        $scope.unrelated_cart.length = 0;

        for (let i = 0; i < orderLines.length; i++) {
            const orderLine = orderLines[i];
            if (orderLine.category_cart_id === $scope.category_cart_id) {
                haveAnyProducts = true;
                const componentID = orderLine.state_ids && orderLine.state_ids.component_id ? orderLine.state_ids.component_id : "unknown_component";
                if (!currentSolutionProducts[componentID]) {
                    currentSolutionProducts[componentID] = [];
                }
                currentSolutionProducts[componentID].push(orderLine);
                if (orderLine.type === "complete") {
                    $scope.complete_only_cart.push(orderLine)
                } else {
                    $scope.non_complete_cart.push(orderLine)
                }
            } else {
                $scope.unrelated_cart.push(orderLine);
            }
        }
    }

    function populateSteps() {

        const componentModel = journeyNavigationModel.state_models.component;
        const componentChoiceList = componentModel ? componentModel.choiceList() : [];
        let stepNumber = 0;

        inputStepChoice = null;

        firstProductStepID = null;

        for (let i = 0; i <= componentChoiceList.length; i++) {
            let stepChoiceID = null;
            let stepName;
            let componentChoice = null;
            if (i === 0) {
                stepChoiceID = "input";
                stepName = "General Options";
            } else {
                componentChoice = componentChoiceList[i - 1];
                stepChoiceID = componentChoice.id;
                stepName = componentChoice.name;
            }

            if (!stepChoiceID) {
                continue;
            }

            stepNumber++;

            let stepChoice = $scope.step_choice_list[i];
            if (!stepChoice || stepChoice.id !== stepChoiceID) {
                stepChoice = new StepChoice(stepChoiceID);
                stepChoice.step_number = stepNumber;
                $scope.step_choice_list[stepNumber - 1] = stepChoice;
            }

            if (stepChoiceID === "input") {
                inputStepChoice = stepChoice;
            } else if (!firstProductStepID) {
                firstProductStepID = stepChoice.id;
            }

            stepChoice.name = stepName;
            stepChoice.component_choice = componentChoice;
        }

        $scope.step_choice_list.length = stepNumber;
    }

    function updateStepChoices() {

        function updateDoorChoice(stepChoice) {

            let solutionFound = false;

            const stateList = journeyNavigationModel.state_list;
            let haveAnyInput = false;
            let inputHasProgress = true;
            const stepValues = [];
            const finishChoices = $rootScope.model.cache_local_server.finish_option.choices;
            for (let i = 0; i < stateList.length; i++) {
                const indexState = stateList[i];
                if (indexState.model_id === "component") {
                    break;
                }

                if (!solutionFound) {
                    if (indexState.state_ids.solution_id) {
                        solutionFound = true;
                    }
                    continue;
                }
                let name = null;
                switch (indexState.model_id) {
                    case "door_type":
                        name = "Door Type";
                        break;
                    case "site_range":
                        name = "Range";
                        break;
                    case "colour_route":
                        name = "Colour";
                        break;
                    case "style_route":
                        name = "Style";
                        break;
                    case "edge_option":
                        name = "Edge Option";
                        break;
                    case "handle_colour":
                        name = "Handle Colour";
                        break;
                    case "assembly":
                        name = "Assembly";
                        break;
                    default:
                        break;
                }
                if (!name) {
                    continue;
                }
                const choiceID = categoryCache.input_choice_ids[indexState.navigation_pointer];
                inputHasProgress = inputHasProgress && !!choiceID;
                haveAnyInput = haveAnyInput || inputHasProgress;

                stepValues.push({
                    name: name,
                    value: inputHasProgress ? indexState.choice.name : "",
                    has_progress: inputHasProgress
                });
                if (indexState.model_id === "colour_route") {
                    let finishName = "";

                    if (inputHasProgress) {
                        if (indexState.choice.finish_ids) {
                            for (let finishID in indexState.choice.finish_ids) {
                                const finishConfig = finishChoices[finishID];
                                if (finishConfig) {
                                    finishName = finishConfig.name;
                                    break;
                                }
                            }
                        }
                    }

                    if (!inputHasProgress || finishName) {
                        stepValues.push({name: "Finish", value: finishName, has_progress: inputHasProgress});
                    }
                }

            }

            let description = "Get underway by pinpointing a";

            for (let i = 0; i < stepValues.length; i++) {
                const stepValue = stepValues[i];
                let descriptionAdd;
                if (i === 0) {
                    descriptionAdd = " ";
                } else if (i === stepValues.length - 1) {
                    descriptionAdd = " and ";
                } else {
                    descriptionAdd = ", ";
                }
                description += descriptionAdd + stepValue.name;
            }

            stepChoice.has_progress = haveAnyInput;
            stepChoice.completed = haveCompleteInput;
            stepChoice.description = description;
            stepChoice.step_values = stepValues;
            stepChoice.status = stepChoice.completed ? "Complete" : "Incomplete"
        }

        function updateProductChoice(stepChoice) {

            const componentChoiceID = stepChoice.component_choice ? stepChoice.component_choice.id : null;
            let orderLines = stepChoice.component_choice ? currentSolutionProducts[componentChoiceID] : null;
            orderLines = orderLines ? orderLines : [];
            const groupedOrderLines = {};

            const displayOrder = [];
            for (let i = 0; i < orderLines.length; i++) {
                const orderLine = orderLines[i];
                if (!groupedOrderLines[orderLine.group_name]) {
                    displayOrder.push(orderLine.group_name)
                    groupedOrderLines[orderLine.group_name] = {
                        name: orderLine.group_name,
                        order_lines: [],
                        quantity: 0
                    }
                }
                groupedOrderLines[orderLine.group_name].order_lines.push(orderLine);
                groupedOrderLines[orderLine.group_name].quantity += orderLine.quantity
            }

            const stepValues = [];
            for (let i = 0; i < displayOrder.length; i++) {
                const groupedOrderLine = groupedOrderLines[displayOrder[i]];
                stepValues.push({name: groupedOrderLine.name, quantity: groupedOrderLine.quantity});
            }

            let description = "";
            let note = "";

            const stateIDs = journeyNavigationModel.state_ids;
            const kitchenBedroom = stateIDs.solution_id !== "bedroom_flat_pack" ? "kitchen" : "bedroom";
            if (stepChoice.id === "solution_cabinet") {

                let hasM2M = stateIDs.assembly_id !== "flat_pack";
                if (journeyNavigationModel.state_ids.site_range_id && !journeyNavigationModel.state_values.site_range_m2m) {
                    hasM2M = false;
                }
                if (hasM2M) {
                    description = "Build your " + kitchenBedroom + " with standard and made-to-measure cabinets";
                } else {
                    description = "Build your " + kitchenBedroom + " from our extensive range of cabinets";
                }
                note = "Please check your default cabinet options";
            } else if (stepChoice.id === "solution_extra") {
                description = "Choose and configure the components to complete your " + kitchenBedroom;
            } else if (stepChoice.id === "select_accessory") {
                description = "Add in the all-important touches and extras";
            } else if (stepChoice.id === "handle_rail") {
                if (stateIDs.solution_id !== "kitchen_inrail") {
                    description = "Finish your look with matching handles";
                } else {
                    description = "Finish your look with matching handleless rails";
                }
            }

            stepChoice.has_progress = stepValues.length > 0 && !stepChoice.disabled;
            stepChoice.completed = stepChoice.has_progress;
            stepChoice.description = description;
            stepChoice.note = note;
            stepChoice.step_values = stepValues;
            stepChoice.status = stepChoice.completed ? "Complete" : (stepChoice.id === "solution_cabinet" ? "Incomplete" : "Optional");
        }

        for (let i = 0; i < $scope.step_choice_list.length; i++) {
            const stepChoice = $scope.step_choice_list[i];
            if (stepChoice.id === "input") {
                updateDoorChoice(stepChoice);
            } else {
                updateProductChoice(stepChoice);
            }
        }
    }

    function requireCategoryCache() {

        categoryCache = $rootScope.service.cache_browse.requireCategoryCache(categoryID);
        if (!categoryCache.category_cart_id) {
            resetCategoryCache();
        } else {
            $scope.category_cart_id = categoryCache.category_cart_id;
        }
    }

    function resetCategoryCache(keepOptionTermIDs) {

        let optionTermIDs = null;
        if (keepOptionTermIDs) {
            optionTermIDs = categoryCache ? categoryCache.option_term_ids : null;
        }

        $rootScope.service.cache_browse.removeCategoryCache(categoryID);
        categoryCache = $rootScope.service.cache_browse.requireCategoryCache(categoryID, createCategoryCartID());
        if (optionTermIDs) {
            categoryCache.option_term_ids = optionTermIDs;
        }
        $scope.category_cart_id = categoryCache.category_cart_id;
    }

    function resetProducts() {

        categoryCache.order_lines.length = 0;
        categoryCache.category_cart_id = createCategoryCartID();
        $rootScope.service.cache_browse.saveCategoryCache(categoryID);
        $scope.category_cart_id = categoryCache.category_cart_id;
        haveAnyProducts = false;
        currentSolutionProducts = {};

    }

    function createCategoryCartID() {
        return categoryID + "_" + Date.now();
    }

    function getExpectedStepID() {

        if (!navigationStepID) {
            if (!navigationInputComplete) {
                return null;
            }
        }

        if (navigationStepID === "input" || !inputStepChoice.completed) {
            return "input";
        }

        if (!navigationStepID) {
            return firstProductStepID;
        }

        return navigationStepID;
    }

    function selectStep(stepID, replace) {

        showInput = stepID === "input";
        const routeIDs = {};
        for (let i = 0; i < journeyNavigationModel.state_list.length; i++) {
            const indexState = journeyNavigationModel.state_list[i];
            if (indexState.navigation_pointer === "component_id") {
                break;
            }
            routeIDs[indexState.navigation_pointer] = indexState.choice_id;
            if (indexState.state_ids.solution_id) {
                if (!stepID || showInput) {
                    break;
                }
            }
        }
        if (stepID && !showInput) {
            for (let i = 0; i < $scope.step_choice_list.length; i++) {
                const stepChoice = $scope.step_choice_list[i];
                if (stepChoice.id === stepID && stepChoice.component_choice) {
                    routeIDs.component_id = stepChoice.component_choice.id;
                }
            }
        }


        lastSelectTime = Date.now();
        setTimeout(function () {
            $scope.$apply();
        }, minSelectElapsedTime + 10);


        const selectDefaults = !!stepID;
        const routeOptions = $rootScope.navigation_manager.createNavigationModel(null, routeIDs, selectDefaults).route_options;
        const options = replace ? {location: 'replace'} : null;
        $state.go(routeOptions.route, routeOptions.options, options)
    }

    function nextStepID(stepID) {
        for (let i = 0; i < $scope.step_choice_list.length - 1; i++) {
            const stepChoice = $scope.step_choice_list[i];
            if (stepChoice.id === stepID) {
                return $scope.step_choice_list[i + 1].id;
            }
        }
        return null;
    }

    function removeCurrentSolutionProductsFromCart() {

        let orderLines = $rootScope.model.order.current_order ? $rootScope.model.order.current_order.lines : null;

        orderLines = orderLines ? orderLines : [];

        let didRemove = false;

        for (let i = 0; i < orderLines.length; i++) {
            const orderLine = orderLines[i];
            if (orderLine.state_ids) {
                if (orderLine.category_cart_id === $scope.category_cart_id) {
                    didRemove = true;
                    $rootScope.model.order.current_order.lines.splice(i, 1);
                    i--;
                }
            }
        }
        haveAnyProducts = false;
        currentSolutionProducts = {};
        if (didRemove) {
            $rootScope.service.order.saveOrder();
        }
    }


    function determineNavigationValues() {

        let solutionFound = false;
        navigationStepID = null;

        const navigationStateList = $rootScope.navigation_model.state_list;
        navigationInputComplete = false;
        for (let i = 0; i < navigationStateList.length; i++) {
            const navigationIndexState = navigationStateList[i];
            if (!solutionFound) {
                if (navigationIndexState.state_ids.solution_id) {
                    solutionFound = true;
                }
                if (showInput) {
                    navigationStepID = "input";
                }
                continue;
            }
            if (navigationIndexState.model_id === "component") {
                showInput = false;
                navigationInputComplete = true;
                navigationStepID = null;

                for (let i = 0; i < $scope.step_choice_list.length; i++) {
                    const stepChoice = $scope.step_choice_list[i];
                    if (stepChoice.component_choice && stepChoice.component_choice.id === navigationIndexState.choice_id) {
                        navigationStepID = stepChoice.id;
                        break;
                    }
                }

                break

            } else {
                if (navigationIndexState.choice_id) {
                    navigationStepID = "input";
                }
            }
        }
    }

    function validateCurrentStep() {
        const expectedStepID = getExpectedStepID();
        if (navigationStepID !== expectedStepID) {
            selectStep(expectedStepID, true);
            return false;
        }
        return true;
    }

    function determineOptionChoices() {
        const optionTermConfig = $rootScope.service.product_solution.genericOptionTermConfig($scope.navigation_ids);
        const optionTermVariationIDs = siteHelper.simpleCloneObject($scope.navigation_ids);
        const cacheOptionTermIDs = categoryCache.option_term_ids;
        $scope.solution_option_terms.length = 0;
        $scope.can_change_cabinet_options = false;
        for (let i = 0; i < optionTermConfig.length; i++) {
            const config = optionTermConfig[i];
            const optionID = config.option_id;
            optionTermVariationIDs.option_id = optionID;

            const optionTermModel = $rootScope.factory.option_term.getModel(optionTermVariationIDs);
            const choiceList = optionTermModel.choiceList();
            if (optionTermModel.disabled || !choiceList.length) {
                continue
            }
            if (choiceList.length) {
                $scope.can_change_cabinet_options = true;
            }

            let optionTermID = choiceList.length === 1 ? choiceList[0].id : cacheOptionTermIDs[optionID];
            const defaultChoiceID = optionTermModel.default_choice_id && optionTermModel.choices[optionTermModel.default_choice_id] ? optionTermModel.default_choice_id : "NONE";

            optionTermID = optionTermID && (optionTermModel.choices[optionTermID] || optionTermID === "NONE") ? optionTermID : defaultChoiceID;

            const solutionOptionTerm = new SolutionOptionTerm(optionID, optionTermModel);
            if (config.required) {
                solutionOptionTerm.required = true;
            }
            solutionOptionTerm.defaultOptionTermID = defaultChoiceID;
            solutionOptionTerm.currentOptionTermID = optionTermID;
            $scope.solution_option_terms.push(solutionOptionTerm);

        }
        $scope.saveSolutionCabinetOptionTerms();
    }

    function checkForDataAPI() {
        $rootScope.service.data_api.productVideosByTags([solutionID, categoryCache.input_choice_ids.assembly_id, "product_intro"], function (videoPosts) {
            for (let i = 0; i < videoPosts.length; i++) {
                const videoPost = videoPosts[i];
                const categorySlug = videoPost.category_list && videoPost.category_list.length > 0 ? videoPost.category_list[0].slug : null;
                const postSlug = videoPost.slug;
                if (categorySlug && postSlug) {
                    $scope.intro_video_link = $state.href("myba.video.category.post", {
                        category_slug: categorySlug,
                        post_slug: postSlug
                    })
                }
            }
        });
    }

    $scope.isStepSelected = function (stepID) {
        return stepID === navigationStepID;
    }

    $scope.onStepClick = function (stepID) {
        if (!$scope.isStepSelected(stepID)) {
            selectStep(stepID);
        } else {
            selectStep(null);
            resetMinimumJourneyViewHeight();
        }
    }

    $scope.saveSolutionCabinetOptionTerms = function () {
        const cacheOptionTermIDs = {};
        for (let i = 0; i < $scope.solution_option_terms.length; i++) {
            const solutionOptionTerm = $scope.solution_option_terms[i];
            const currentOptionTermID = solutionOptionTerm.currentOptionTermID;
            if (currentOptionTermID) {
                cacheOptionTermIDs[solutionOptionTerm.option_id] = currentOptionTermID;
            }
        }
        categoryCache.option_term_ids = cacheOptionTermIDs;
        $rootScope.service.cache_browse.saveCategoryCache(categoryID);
    }

    $scope.isIncludeDelayRequired = function () {
        const now = Date.now();
        const elapsed = now - lastSelectTime;
        return elapsed < minSelectElapsedTime;
    }

    $scope.canResetSolution = function () {
        return (inputStepChoice && inputStepChoice.has_progress) || haveAnyProducts;
    }

    $scope.consolidateCarts = function () {


        let orderLines = $rootScope.model.order.current_order ? $rootScope.model.order.current_order.lines : null;

        orderLines = orderLines ? orderLines : [];

        const didChange = false;
        for (let i = 0; i < orderLines.length; i++) {
            const orderLine = orderLines[i];
            const stateIDs = orderLine.state_ids ? orderLine.state_ids : {}
            if (stateIDs.solution_id === solutionID && orderLine.category_cart_id !== $scope.category_cart_id) {
                orderLine.category_cart_id = $scope.category_cart_id;
            }
        }

        if (didChange) {
            $rootScope.service.order.saveOrder();
        }

        updateSolution();

    }

    $scope.resetSolution = function () {
        const previousNavigationStepID = navigationStepID;
        removeCurrentSolutionProductsFromCart();
        resetCategoryCache(true);
        if (previousNavigationStepID) {
            determineOptionChoices();
            selectStep(null);
        } else {
            populateSolution();
        }
    }

    $scope.$on('browse_navigation_state_change', function () {
        if ($rootScope.navigation_model.state_ids.solution_id !== journeyNavigationModel.state_ids.solution_id) {
            return;
        }

        let inputDidChange = false;
        for (let i = 0; i < Math.max(journeyNavigationModel.state_list.length, $rootScope.navigation_model.state_list.length); i++) {
            const routeState = journeyNavigationModel.state_list[i];
            const navigationState = $rootScope.navigation_model.state_list[i];
            const modelID = navigationState ? navigationState.model_id : routeState.model_id;
            if (modelID === "component") {
                break;
            }
            const navigationPointer = navigationState ? navigationState.navigation_pointer : routeState.navigation_pointer;
            let routeChoiceID = categoryCache.input_choice_ids[navigationPointer];
            let navigationChoiceID = navigationState ? navigationState.choice_id : routeState.choice_id;
            routeChoiceID = routeChoiceID ? routeChoiceID : null;
            navigationChoiceID = navigationChoiceID ? navigationChoiceID : null;
            if (routeChoiceID !== navigationChoiceID) {
                inputDidChange = true;
                break;
            }
        }

        if (inputDidChange) {
            updateSolution();
        }
        determineNavigationValues();
        if (validateCurrentStep()) {
            $scope.validatePagePosition();
        }
    });

    $scope.checkHeight = function () {
        if (!$scope.do_fix_height) {
            return
        }

        const journeyMain = document.getElementById('journey-main');
        const currentHeight = journeyMain.offsetHeight;
        if (currentHeight > $scope.minimum_journey_view_height) {
            setTimeout(function () {
                const currentHeight = journeyMain.offsetHeight;
                if (currentHeight > $scope.minimum_journey_view_height) {
                    $scope.minimum_journey_view_height = currentHeight;
                    $scope.$apply();
                }
            }, 1000)
        }
        applyValidatePagePosition();
    }

    $scope.validatePagePosition = function () {
        setTimeout(function () {
            validatePagePositionCalled = true;
            $scope.$apply();
        }, 100);
    }

    function applyValidatePagePosition() {
        if (!validatePagePositionCalled) {
            return
        }
        validatePagePositionCalled = false
        let target = null;
        let buffer = 0;
        if (!navigationStepID) {
            target = 0;
        } else {
            target = null;
            const $headerElement = $("#component-accordion-header-" + navigationStepID);
            if ($headerElement.length) {
                target = Math.floor($headerElement.offset().top) - 50;
                target = Math.max(target, 0);
                buffer = -1;
            }
        }
        if (target !== null) {
            const scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
            if (scrollTop > target + buffer) {
                document.body.scrollTop = document.documentElement.scrollTop = target;
            }
        }
    }


    const resetMinimumJourneyViewHeight = function () {
        $scope.minimum_journey_view_height = 0;
        $scope.checkHeight();
    }

    $window.addEventListener('resize', resetMinimumJourneyViewHeight);

    //Listen to when the cart changes an update the view
    const unbindCurrentOrderReplaced = $rootScope.$on('current_order_replaced', function ($event, params) {
        updateSolution()
        $scope.have_solution_order_data = true;
    })

    function handleDestroy() {
        unbindCurrentOrderReplaced();
        $window.removeEventListener('resize', resetMinimumJourneyViewHeight);
    }

    $scope.$on('$destroy', handleDestroy);

    populateSolution();

}])